export const FETCH_ENTITY = 'ENTITY/FETCH_REQUEST';
export const FETCH_ENTITY_SUCCESS = 'ENTITY/FETCH_SUCCESS';
export const FETCH_ENTITY_FAILURE = 'ENTITY/FETCH_FAILURE';

export const READ_ENTITY = 'ENTITY/READ_REQUEST';
export const READ_ENTITY_SUCCESS = 'ENTITY/READ_SUCCESS';
export const READ_ENTITY_FAILURE = 'ENTITY/READ_FAILURE';

export const SET_DOCUMENT_SIGNATURE_LOADING = 'ENTITY/SET_DOCUMENT_SIGNATURE_LOADING';

export const SIGN_DOCUMENTS = 'ENTITY/SIGN_DOCUMENTS_REQUEST';
export const SIGN_DOCUMENTS_FAILURE = 'ENTITY/SIGN_DOCUMENTS_FAILURE';

export const OPEN_SIGNATURE_MODAL = 'ENTITY/OPEN_SIGNATURE_MODAL';
export const CLOSE_SIGNATURE_MODAL = 'ENTITY/CLOSE_SIGNATURE_MODAL';

export const OPEN_SIGN_HERE_MODAL = 'ENTITY/OPEN_SIGN_HERE_MODAL';
export const CLOSE_SIGN_HERE_MODAL = 'ENTITY/CLOSE_SIGN_HERE_MODAL';

export const MARK_SIGNATURE_DOCUMENTS_DISMISSED = 'ENTITY/MARK_SIGNATURE_DOCUMENTS_DISMISSED';

export const SEND_RATING = 'ENTITY/RATINGS/SEND_REQUEST';
export const SEND_RATING_SUCCESS = 'ENTITY/RATINGS/SEND_SUCCESS';
export const SEND_RATING_FAILURE = 'ENTITY/RATINGS/SEND_FAILURE';
